import { render, staticRenderFns } from "./EmailProviders.vue?vue&type=template&id=13842fe0&"
import script from "./EmailProviders.vue?vue&type=script&lang=js&"
export * from "./EmailProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports